import React from 'react';

interface IconLabelProps {
	label: string
	iconEnabled?: boolean
	iconPosition?: 'left' | 'right'
	icon: any
	link?: string
	target?: string
}

export const IconLabel = ({ iconPosition = 'right', iconEnabled = true, ...props }: IconLabelProps) => {
	return (
		<div className='d-flex' style={{ flexDirection: iconPosition === 'right' ? 'row' : 'row-reverse' }}>
			<>{props.label}</>

			{!!iconEnabled && (
				props.link
					? (
						<a href={props.link} className='text-dark ms-1 me-1' target={props.target ?? '_blank'} rel="noopener noreferrer">
							{props.icon}
						</a>
					)
					: props.icon
			)}
		</div>
	);
};

export default IconLabel;
